import Vue from "vue";
import {APIHOST} from "@/settings/server";
import $store from "../store";
import _ from 'underscore'
import axios from "axios";

class AccountService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getTree() {
        return Vue.axios.get(`${APIHOST}/api/AccountTree`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getLogin(username) {
        return Vue.axios.get(`${APIHOST}/api/Login`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    changePassword({username, password}) {
        return Vue.axios.put(`${APIHOST}/api/ChangeAccountPassword`, {
            Password: password
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            }
        })
    }

    changeName({username, name}) {
        return Vue.axios.put(`${APIHOST}/api/ChangeAccountName`, {
            Name: name
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            }
        })
    }

    changeAccount({username, permissions, region, areas, accountType, postIndex}) {
        return Vue.axios.put(`${APIHOST}/api/ChangeAccount`, {
            Permissions: _.map(permissions, p => {
                return p.id
            }),
            Regions: _.map(region, r => {
                return r.id
            }),
            Areas: _.map(areas, a => {
                return a.id
            }),
            Type: accountType.id,
            PostIndex: typeof (postIndex) === 'string' && postIndex ? postIndex : null
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: username
            }
        })
    }

    createAccount({username, permissions, region, areas, accountType, postIndex, name, password}) {
        return Vue.axios.post(`${APIHOST}/api/CreateAccount`, {
            Permissions: _.map(permissions, p => {
                return p.id
            }),
            Regions: _.map(region, r => {
                return r.id
            }),
            Areas: _.map(areas, a => {
                return a.id
            }),
            Type: accountType.id,
            PostIndex: typeof (postIndex) === 'string' && postIndex ? postIndex : null,
            Name: name,
            Password: password,
            Username: username
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }
}

export default new AccountService()